<!--
  Created by Caroline on 2019/11/22 0022.
-->
<template>
<!--  <div class="wrapper" :style="'transform: scale(' + scale + ')'">-->
  <div class="wrapper" :class="[{'fw-bold': globalFont.bold}, globalFont.size]">
    <template v-if="modeData">
      <template v-if="(!isFixScreen && modeData.mode === 3) || (isFixScreen && 3 === fixMode)">
        <lottery></lottery>
      </template>

      <template v-else-if="(!isFixScreen && modeData.mode === 2) || (isFixScreen && 2 === fixMode)">
        <bless></bless>
      </template>

      <template v-else-if="(!isFixScreen && modeData.mode === 1) || (isFixScreen && 1 === fixMode)">
        <album></album>
      </template>

      <template v-else>
        <wait></wait>
      </template>

      <setting @fixScreen="fixScreen"></setting>
    </template>

  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: "preview",
    components: {
    },
    data() {
      return {
        isFixScreen: false,
        fixMode: -1,
      }
    },
    computed: {
      ...mapState(['activityId', 'modeData', 'shareData', 'toast', 'globalFont']),
      ...mapGetters(['scale']),
    },
    watch: {
      activityId (val) {
        if(val){
          this.getShareData()
          this.getAllBlessingList()
        }
      },
      modeData (val) {
        // console.log("preview watch modeData", val);
        if(val.mode === 1){
          // let tagIds = val.albumConfig.tags.filter(item => item.show).map(item => item.id)
          // let param = {tagIds: tagIds, showUserImage: val.albumConfig.showUserImage}
          // this.getImageList(param)
          this.getImageList()
        }
      },
    },
    created() {
    },
    mounted() {
    },
    methods: {
      ...mapActions(['getShareData', 'getImageList', 'getAllBlessingList', 'hideToast', ]),
      fixScreen (val) {
        this.isFixScreen = val
        this.fixMode = this.modeData.mode
        console.log(this.fixMode, this.isFixScreen,this.isFixScreen && this.modeData.mode === this.fixMode)
      }
    },
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/preview.less";

</style>



// WEBPACK FOOTER //
// src/pages/Preview.vue